// extracted by mini-css-extract-plugin
export var gap1 = "Rows-module--gap1--20da2";
export var gap10 = "Rows-module--gap10--34907";
export var gap2 = "Rows-module--gap2--d5b86";
export var gap3 = "Rows-module--gap3--21cc2";
export var gap4 = "Rows-module--gap4--e0898";
export var gap5 = "Rows-module--gap5--386d3";
export var gap6 = "Rows-module--gap6--6231b";
export var gap7 = "Rows-module--gap7--da645";
export var gap8 = "Rows-module--gap8--77046";
export var gap9 = "Rows-module--gap9--44a96";
export var wrapper = "Rows-module--wrapper--70f3b";